export default __webpack_public_path__ + "static/media/visas.2e85ae30.svg";